<script>
import {supabase} from "./supabaseClient"
import router from 'page'
import { fade } from 'svelte/transition';

import StandardHeader from "./StandardHeader.svelte"
import StandardFooter from "./StandardFooter.svelte"

const handleSignOut = async () => {
  let { error } = await supabase.auth.signOut()
}

let email;
let password;
let errorMessage ='';

const handleLogin = async () => {
  const {
    data: { user },
    error,
  } = await supabase
    .auth
  .signInWithPassword({ email, password })

  // let { user, error } = await supabase.auth.signIn({
  // email: email,
  // password: password
  // })
  if (error) {
    errorMessage = error.message
    return;
  }
  const urlParams = new URLSearchParams(window.location.search);
  const redirect = urlParams.has('redirect');
  if (redirect){
    router.redirect(urlParams.get('redirect'))
  } else {
  router.redirect('/myboards')
  }
}
</script>

<div class="pageContainer">
  <StandardHeader />
  <div class="mainContentSection" style="min-width:300px">

    <form on:submit|preventDefault={handleLogin} style="width:100%; max-width: 360px" id="Login">

      <div class="self-start font-bold mb-2">Sign In</div>

          <div class="mb-3">
            <input
              type="email"
              placeholder="Email"
              bind:value={email}
              on:input={() => errorMessage = ''}
              class="input input-bordered w-full"
            />
          </div>

          <div class="mb-3">
            <input
              type="password"
              placeholder="Password"
              bind:value={password}
              on:input={() => errorMessage = ''}
              class="input input-bordered w-full border-[var--aqua]"
            />
          </div>

          {#if errorMessage}
            <div class="text-red-600 text-sm mb-3" in:fade>{{ errorMessage }}</div>
          {/if}

          <div class="flex justify-end">
            <button
              id="LoginButton"
              type="submit"
              class="btn bg-[var(--aqua)] text-white hover:opacity-90"
            >
              Login
            </button>
          </div>




      <!-- <div style="align-self: flex-start"><b>Sign In </b></div>
      <div><input type="email" placeholder="Email" bind:value={email} style="width:100%" on:input={() => errorMessage=''} /> </div>
      <div><input placeholder="Password" type="password" bind:value={password} style="width:100%" on:input={() => errorMessage=''}  /> </div>
      {#if errorMessage != ''}
          <div style="color:red" in:fade="{{ y: 200, duration: 1500 }}">{errorMessage}</div>
      {/if}
      <div><button id="LoginButton" class="primary" style="float:right" type="submit">Login</button> </div> -->
    </form>
    <div style="text-align:center"><a href="/RequestPasswordReset">Forgot your Password?</a></div>

  </div>
  <StandardFooter/>
</div>

<style>
.pageContainer{min-height:100vh;  display: flex; flex-direction: column; }
.mainContentSection {min-height: calc(100vh - 200px);  display: flex; flex-direction: column; align-self: center; justify-content: center}
</style>
